import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get contacts
 * */
export function* getContacts() {
    const response = yield call(api.getContracts);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_CONTRACTS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_CONTRACTS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetContacts() {
    while (true) {
        yield take(actionTypes.GET_CONTRACTS.REQUEST);
        yield fork(getContacts);
    }
}

export function* getTimeContacts() {
    const response = yield call(api.getTimeContracts);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_TIME_CONTRACTS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_TIME_CONTRACTS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetTimeContacts() {
    while (true) {
        yield take(actionTypes.GET_TIME_CONTRACTS.REQUEST);
        yield fork(getTimeContacts);
    }
}

export default [
    watchGetContacts,
    watchGetTimeContacts,
];



// WEBPACK FOOTER //
// ./app/sagas/contacts.js